module.exports = __webpack_public_path__ + "static/logos/surf-forecast__logo--black-3d733415c6a176dc0104a7f79bea7571.svg";